import React, { useState } from 'react';
import { Select } from '../ui';
import DotsLoading from '../ui/DotsLoading';
import { updateAppointmentStatus } from '../../services/appointment';
import styled from '@emotion/styled';

const statusOptions = [
    { value: 'completed', label: 'Completed' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'cancelled', label: 'Cancelled' },
];

const Toast = styled.div`
  position: fixed;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  background: #F43F60;
  color: #fff;
  padding: 16px 32px;
  border-radius: 12px;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  z-index: 9999;
  box-shadow: 0 2px 16px rgba(0,0,0,0.12);
  
  @media (max-width: 768px) {
    top: 24px;
    padding: 12px 24px;
    font-size: 1rem;
    border-radius: 10px;
    max-width: 90vw;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    top: 16px;
    padding: 10px 20px;
    font-size: 0.9rem;
    border-radius: 8px;
    max-width: 95vw;
  }
`;

const SelectContainer = styled.div`
  width: 100%;
  min-width: 120px;
  
  @media (max-width: 768px) {
    min-width: 100px;
  }
  
  @media (max-width: 480px) {
    min-width: 80px;
  }
`;

const AppointmentStatusUpdateContainer = ({ appointment, onStatusChange }) => {
    const [status, setStatus] = useState(appointment.status);
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState('');

    const handleChange = async (e) => {
        const newStatus = e.target.value;
        const prevStatus = status;
        setStatus(newStatus);
        setLoading(true);
        try {
            const res = await updateAppointmentStatus(appointment.id, { status: newStatus });
            if (res.status !== 'success') {
                throw new Error(res.message || 'Failed to update status');
            }
            setStatus(newStatus);
            onStatusChange && onStatusChange(newStatus);
        } catch (err) {
            setStatus(prevStatus);
            setToastMsg(err.message || 'Failed to update status');
            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SelectContainer>
                {loading ? (
                    <DotsLoading dots={3} color="#F43F60" />
                ) : (
                    <Select
                        value={status}
                        size="small"
                        onChange={handleChange}
                        options={statusOptions}
                        placeholder="Select status"
                        aria-label="Update appointment status"
                    />
                )}
            </SelectContainer>
            {showToast && <Toast>{toastMsg}</Toast>}
        </>
    );
};

export default AppointmentStatusUpdateContainer; 